import { useHistory } from "react-router-dom";

import { AssessmentContainer } from "./components/AssessmentContainer";

export function SNSEAssessment() {
  const history = useHistory();

  return (
    <AssessmentContainer
      definitionId="snse"
      onSuccessCallback={() => history.push("/app/home")}
      taskType="COMPLETE_SNSE_ASSESSMENT"
      toastConfig={{
        heading: "Social Needs Check-In complete.",
        text: "Your care team will review your answers.",
      }}
    />
  );
}
